import Map, { Marker } from "react-map-gl";
import { Box, Button } from "@mui/material";

export default function CustomMarkerMap({ viewState, setViewState, onCreate }) {
  return (
    <Marker
      longitude={viewState.longitude}
      latitude={viewState.latitude}
      anchor="bottom"
      draggable
      onDragEnd={(e) => {
        setViewState((prev) => ({
          ...prev,
          longitude: e.lngLat.lng,
          latitude: e.lngLat.lat,
        }));
      }}
      style={{
        top: "10%",
      }}
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        sx={{
          transition: "transform 0.25s ease-out, opacity 0.25s ease-out",
          "&:active": {
            transform: "scale(1.05)", // small bounce on drag
            opacity: 0.9,
          },
        }}
      >
        {/* Square Box */}
        <Box
          width={120}
          height={120}
          border="2px solid white"
          bgcolor="rgba(0,0,0,0.3)"
          borderRadius={1}
          display="flex"
          justifyContent="center"
          alignItems="center"
          boxShadow={3}
          sx={{
            transition: "all 0.3s ease-in-out",
          }}
        >
          {/* Center Dot */}
          <Box
            width={12}
            height={12}
            borderRadius="50%"
            bgcolor="white"
            boxShadow={2}
            sx={{ transition: "all 0.3s ease-in-out" }}
          />
        </Box>

        {/* Button Below */}
        <Button
          variant="contained"
          color="primary"
          size="small"
          sx={{
            mt: 1,
            fontWeight: "bold",
            transition: "all 0.3s ease-in-out",
            "&:hover": {
              transform: "translateY(-2px)",
              boxShadow: 4,
            },
          }}
          onClick={onCreate}
        >
          CREATE PROJECT
        </Button>
      </Box>
    </Marker>
  );
}
